import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { getError } from 'src/domains/layouts/webview/components/common/errorMessage/getError';
import { ErrorMessageWrapper, WarningIconWrapper } from './styles';
import { UniverseVersion } from 'src/domains/common/UniverseVersion';
import { UniverseType } from 'src_common/common/universe';

import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface ErrorMessageDeprecatedPropsType {
    message: string | {};
    children?: React.ReactNode;
    hasWarningIcon?: boolean;
}

/** * @deprecated - Please use {@link Messages} instead. */
export const ErrorMessageDeprecated = observer(
    'ErrorMessage',
    (props: ErrorMessageDeprecatedPropsType): JSX.Element => {
        const { message, children, hasWarningIcon = false } = props;
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;

        return (
            <ErrorMessageWrapper
                data-test='error-message-deprecated-content'
                variant={configState.componentVariants.betslipVariant}
            >
                {hasWarningIcon ? <WarningIconWrapper /> : null}
                <UniverseVersion>
                    {(universe: UniverseType): React.ReactElement => (
                        <div>
                            {getError(universe, message)}
                            {children !== undefined && children}
                        </div>
                    )}
                </UniverseVersion>
            </ErrorMessageWrapper>
        );
    }
);
